<template>
  <div>
    <div class="my-3">
      Sign up for a monthly forward-looking roundup of upcoming elections. This
      will be sent at the beginning of every month.
    </div>
    <LocationsSelector
      :selected-locations="notification.formatted.params.locations"
      :read-only="readOnly"
      @change-locations="handleChangeLocations"
    ></LocationsSelector>
  </div>
</template>

<script>
import lodashCloneDeep from "lodash/cloneDeep";

import { MODULE_PREFIX_NOTIFICATIONS } from "@/store";
import { GET_NOTIFICATION } from "@/store/actions.type";
import { mapGetters } from "vuex";

export default {
  name: "NotificationsBriefingsElectionsWatch",
  components: {
    LocationsSelector: () => import("@/components/common/LocationsSelector"),
  },
  props: {
    readOnly: {
      type: Boolean,
      default: false,
    },
  },
  data: () => ({}),
  computed: {
    ...mapGetters({
      notification: MODULE_PREFIX_NOTIFICATIONS + "notification",
    }),
  },
  mounted() {},
  methods: {
    handleChangeLocations(locations) {
      const notification = lodashCloneDeep(this.notification);
      notification.formatted = notification.formatted || {};
      notification.formatted.params = notification.formatted.params || {};
      notification.formatted.params.locations = locations;
      this.update(notification);
    },
    update(notification) {
      this.$store.dispatch(
        MODULE_PREFIX_NOTIFICATIONS + GET_NOTIFICATION,
        notification
      );
    },
  },
  watch: {},
};
</script>

<style scoped></style>
